export enum EMediaType {
  Photo = 'photo',
}

export type TMedia = {
  type: EMediaType.Photo;
  src: string;
  thumbnailSrc: string;
};
